import React, { Component } from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans } from "react-i18next";
import Button from "@material-ui/core/Button";

/**
 * Wraps children inside a Material UI dialog with the heading "Are you sure?"
 * and two actions: "Yes" and "No".
 */
export class AreYouSureDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          aria-labelledby="are-you-sure-dialog-title"
          aria-describedby="are-you-sure-dialog-description"
        >
          <DialogTitle id="are-you-sure-dialog-title">
            <Trans i18nKey="global_are_you_sure" />
          </DialogTitle>
          <DialogContent id="are-you-sure-dialog-description">
            {this.props.children}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose} color="primary">
              <Trans i18nKey="global_no" />
            </Button>
            <Button onClick={this.props.onSubmit} color="primary">
              <Trans i18nKey="global_yes" />
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AreYouSureDialog;
